import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type RequireFields<T, K extends keyof T> = { [X in Exclude<keyof T, K>]?: T[X] } & { [P in K]-?: NonNullable<T[P]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  DateTime: Date;
  JSON: any;
  Time: any;
};


export type Certificate = {
  __typename?: 'Certificate';
  _id: Scalars['ID'];
  academyId: Scalars['ID'];
  certificateConfiguration: CertificateConfiguration;
  certificateConfigurationId: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  name: Scalars['String'];
  questions: Array<Scalars['JSON']>;
  quizFinishedAt?: Maybe<Scalars['DateTime']>;
  quizStartedAt?: Maybe<Scalars['DateTime']>;
  receivedPointsPercentage?: Maybe<Scalars['Int']>;
  requiredPassingThresholdPercentage: Scalars['Int'];
  state: CertificateState;
  timeLimitMs: Scalars['Int'];
  url?: Maybe<Scalars['String']>;
  user: User;
  userId: Scalars['ID'];
};

export type CertificateConfiguration = {
  __typename?: 'CertificateConfiguration';
  _id: Scalars['ID'];
  academyId: Scalars['String'];
  description: Array<Scalars['JSON']>;
  name: Scalars['String'];
  numOfQuestions: Scalars['Int'];
  passingThresholdPercentage: Scalars['Int'];
  timeLimitMs: Scalars['Int'];
  topic: Topic;
  topicId: Scalars['String'];
};

export type CertificateConfigurationInput = {
  description: Array<Scalars['JSON']>;
  name: Scalars['String'];
  numOfQuestions: Scalars['Int'];
  passingThresholdPercentage: Scalars['Int'];
  timeLimitMs: Scalars['Int'];
  topicId: Scalars['String'];
};

export enum CertificateState {
  Failed = 'Failed',
  InProgress = 'InProgress',
  Passed = 'Passed',
  Pending = 'Pending'
}



export type Hook = {
  __typename?: 'Hook';
  _id: Scalars['ID'];
  academyId: Scalars['ID'];
  action: HookAction;
  name: Scalars['String'];
  trigger: HookTrigger;
};

export type HookAction = {
  __typename?: 'HookAction';
  config: Scalars['JSON'];
  type: HookActionType;
};

export type HookActionInput = {
  config: Scalars['JSON'];
  type: HookActionType;
};

export enum HookActionType {
  CreateCertificate = 'CREATE_CERTIFICATE'
}

export type HookInput = {
  action: HookActionInput;
  name: Scalars['String'];
  trigger: HookTriggerInput;
};

export type HookTrigger = {
  __typename?: 'HookTrigger';
  config: Scalars['JSON'];
  type: HookTriggerType;
};

export type HookTriggerInput = {
  config: Scalars['JSON'];
  type: HookTriggerType;
};

export enum HookTriggerType {
  UserParticipatedEventForTraining = 'USER_PARTICIPATED_EVENT_FOR_TRAINING'
}


export type Mutation = {
  __typename?: 'Mutation';
  answerQuestion: PublicCertificate;
  createCertificate: Certificate;
  createCertificateConfiguration: CertificateConfiguration;
  createHook: Hook;
  createTopic: Topic;
  deleteCertificate: Scalars['Boolean'];
  deleteCertificateConfiguration: Scalars['Boolean'];
  deleteHook: Scalars['Boolean'];
  deleteTopic: Scalars['Boolean'];
  echo: Scalars['String'];
  generateCertificatePdf: Scalars['String'];
  softDeleteCertificateConfiguration: Scalars['Boolean'];
  startPublicCertification: PublicCertificate;
  updateCertificateConfiguration: CertificateConfiguration;
  updateHook: Hook;
  updateTopic: Topic;
};


export type MutationAnswerQuestionArgs = {
  answer: Scalars['JSON'];
  certificateId: Scalars['ID'];
  questionId: Scalars['ID'];
};


export type MutationCreateCertificateArgs = {
  certificateConfigurationId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationCreateCertificateConfigurationArgs = {
  academyId: Scalars['String'];
  certificateConfiguration: CertificateConfigurationInput;
};


export type MutationCreateHookArgs = {
  academyId: Scalars['ID'];
  hook: HookInput;
};


export type MutationCreateTopicArgs = {
  academyId: Scalars['String'];
  name: Scalars['String'];
};


export type MutationDeleteCertificateArgs = {
  _id: Scalars['ID'];
};


export type MutationDeleteCertificateConfigurationArgs = {
  _id: Scalars['ID'];
};


export type MutationDeleteHookArgs = {
  _id: Scalars['ID'];
};


export type MutationDeleteTopicArgs = {
  _id: Scalars['ID'];
};


export type MutationEchoArgs = {
  str: Scalars['String'];
};


export type MutationGenerateCertificatePdfArgs = {
  certificateId: Scalars['ID'];
};


export type MutationSoftDeleteCertificateConfigurationArgs = {
  _id: Scalars['ID'];
};


export type MutationStartPublicCertificationArgs = {
  _id: Scalars['ID'];
};


export type MutationUpdateCertificateConfigurationArgs = {
  _id: Scalars['ID'];
  certificateConfiguration: CertificateConfigurationInput;
};


export type MutationUpdateHookArgs = {
  _id: Scalars['ID'];
  hook: HookInput;
};


export type MutationUpdateTopicArgs = {
  _id: Scalars['ID'];
  topic: TopicInput;
};

export type PaginatedCertificatesList = {
  __typename?: 'PaginatedCertificatesList';
  certificates: Array<Certificate>;
  documentCount: Scalars['Int'];
};

export type PublicCertificate = {
  __typename?: 'PublicCertificate';
  _id: Scalars['ID'];
  certificateConfiguration: PublicCertificateConfiguration;
  createdAt: Scalars['DateTime'];
  currentQuestion?: Maybe<Scalars['JSON']>;
  name: Scalars['String'];
  numOfQuestions: Scalars['Int'];
  numOfQuestionsAnswered: Scalars['Int'];
  questions: Array<Scalars['JSON']>;
  quizFinishedAt?: Maybe<Scalars['DateTime']>;
  quizStartedAt?: Maybe<Scalars['DateTime']>;
  receivedPointsPercentage?: Maybe<Scalars['Int']>;
  requiredPassingThresholdPercentage: Scalars['Int'];
  state: CertificateState;
  timeLimitMs: Scalars['Int'];
  user: PublicUser;
};

export type PublicCertificateConfiguration = {
  __typename?: 'PublicCertificateConfiguration';
  _id: Scalars['ID'];
  description: Array<Scalars['JSON']>;
  name: Scalars['String'];
};

export type PublicUser = {
  __typename?: 'PublicUser';
  _id: Scalars['ID'];
  email: Scalars['String'];
  firstname: Scalars['String'];
  lastname: Scalars['String'];
  name: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  certificate?: Maybe<Certificate>;
  certificateConfiguration?: Maybe<CertificateConfiguration>;
  certificateConfigurations: Array<CertificateConfiguration>;
  certificates: PaginatedCertificatesList;
  hook?: Maybe<Hook>;
  hooks: Array<Hook>;
  myCertificates: Array<Certificate>;
  publicCertificate?: Maybe<PublicCertificate>;
  topic?: Maybe<Topic>;
  topics: Array<Topic>;
  trainings: Array<Training>;
  users: Array<User>;
  version: Scalars['String'];
};


export type QueryCertificateArgs = {
  _id: Scalars['ID'];
};


export type QueryCertificateConfigurationArgs = {
  _id: Scalars['ID'];
};


export type QueryCertificateConfigurationsArgs = {
  academyId: Scalars['String'];
};


export type QueryCertificatesArgs = {
  academyId: Scalars['String'];
  limit: Scalars['Int'];
  page: Scalars['Int'];
};


export type QueryHookArgs = {
  _id: Scalars['ID'];
};


export type QueryHooksArgs = {
  academyId: Scalars['ID'];
};


export type QueryPublicCertificateArgs = {
  _id: Scalars['ID'];
};


export type QueryTopicArgs = {
  _id: Scalars['ID'];
};


export type QueryTopicsArgs = {
  academyId: Scalars['String'];
};


export type QueryTrainingsArgs = {
  academyId: Scalars['ID'];
};


export type QueryUsersArgs = {
  search?: Maybe<Scalars['String']>;
};


export type Topic = {
  __typename?: 'Topic';
  _id: Scalars['ID'];
  academyId: Scalars['String'];
  name: Scalars['String'];
  questions: Array<Scalars['JSON']>;
};

export type TopicInput = {
  name: Scalars['String'];
  questions: Array<Scalars['JSON']>;
};

export type Training = {
  __typename?: 'Training';
  _id: Scalars['ID'];
  name: Scalars['String'];
};

export type User = {
  __typename?: 'User';
  _id: Scalars['ID'];
  email: Scalars['String'];
  firstname: Scalars['String'];
  lastname: Scalars['String'];
  name: Scalars['String'];
};

export type UserInput = {
  assignedWorkflows: Array<Scalars['String']>;
};



export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterator<TResult> | Promise<AsyncIterator<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  Boolean: ResolverTypeWrapper<Scalars['Boolean']>;
  Certificate: ResolverTypeWrapper<Certificate>;
  CertificateConfiguration: ResolverTypeWrapper<CertificateConfiguration>;
  CertificateConfigurationInput: CertificateConfigurationInput;
  CertificateState: CertificateState;
  Date: ResolverTypeWrapper<Scalars['Date']>;
  DateTime: ResolverTypeWrapper<Scalars['DateTime']>;
  Hook: ResolverTypeWrapper<Hook>;
  HookAction: ResolverTypeWrapper<HookAction>;
  HookActionInput: HookActionInput;
  HookActionType: HookActionType;
  HookInput: HookInput;
  HookTrigger: ResolverTypeWrapper<HookTrigger>;
  HookTriggerInput: HookTriggerInput;
  HookTriggerType: HookTriggerType;
  ID: ResolverTypeWrapper<Scalars['ID']>;
  Int: ResolverTypeWrapper<Scalars['Int']>;
  JSON: ResolverTypeWrapper<Scalars['JSON']>;
  Mutation: ResolverTypeWrapper<{}>;
  PaginatedCertificatesList: ResolverTypeWrapper<PaginatedCertificatesList>;
  PublicCertificate: ResolverTypeWrapper<PublicCertificate>;
  PublicCertificateConfiguration: ResolverTypeWrapper<PublicCertificateConfiguration>;
  PublicUser: ResolverTypeWrapper<PublicUser>;
  Query: ResolverTypeWrapper<{}>;
  String: ResolverTypeWrapper<Scalars['String']>;
  Time: ResolverTypeWrapper<Scalars['Time']>;
  Topic: ResolverTypeWrapper<Topic>;
  TopicInput: TopicInput;
  Training: ResolverTypeWrapper<Training>;
  User: ResolverTypeWrapper<User>;
  UserInput: UserInput;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  Boolean: Scalars['Boolean'];
  Certificate: Certificate;
  CertificateConfiguration: CertificateConfiguration;
  CertificateConfigurationInput: CertificateConfigurationInput;
  Date: Scalars['Date'];
  DateTime: Scalars['DateTime'];
  Hook: Hook;
  HookAction: HookAction;
  HookActionInput: HookActionInput;
  HookInput: HookInput;
  HookTrigger: HookTrigger;
  HookTriggerInput: HookTriggerInput;
  ID: Scalars['ID'];
  Int: Scalars['Int'];
  JSON: Scalars['JSON'];
  Mutation: {};
  PaginatedCertificatesList: PaginatedCertificatesList;
  PublicCertificate: PublicCertificate;
  PublicCertificateConfiguration: PublicCertificateConfiguration;
  PublicUser: PublicUser;
  Query: {};
  String: Scalars['String'];
  Time: Scalars['Time'];
  Topic: Topic;
  TopicInput: TopicInput;
  Training: Training;
  User: User;
  UserInput: UserInput;
};

export type UnauthenticatedDirectiveArgs = {  };

export type UnauthenticatedDirectiveResolver<Result, Parent, ContextType = any, Args = UnauthenticatedDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type CertificateResolvers<ContextType = any, ParentType extends ResolversParentTypes['Certificate'] = ResolversParentTypes['Certificate']> = {
  _id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  academyId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  certificateConfiguration?: Resolver<ResolversTypes['CertificateConfiguration'], ParentType, ContextType>;
  certificateConfigurationId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  questions?: Resolver<Array<ResolversTypes['JSON']>, ParentType, ContextType>;
  quizFinishedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  quizStartedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  receivedPointsPercentage?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  requiredPassingThresholdPercentage?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  state?: Resolver<ResolversTypes['CertificateState'], ParentType, ContextType>;
  timeLimitMs?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  user?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CertificateConfigurationResolvers<ContextType = any, ParentType extends ResolversParentTypes['CertificateConfiguration'] = ResolversParentTypes['CertificateConfiguration']> = {
  _id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  academyId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<Array<ResolversTypes['JSON']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  numOfQuestions?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  passingThresholdPercentage?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  timeLimitMs?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  topic?: Resolver<ResolversTypes['Topic'], ParentType, ContextType>;
  topicId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface DateScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Date'], any> {
  name: 'Date';
}

export interface DateTimeScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['DateTime'], any> {
  name: 'DateTime';
}

export type HookResolvers<ContextType = any, ParentType extends ResolversParentTypes['Hook'] = ResolversParentTypes['Hook']> = {
  _id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  academyId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  action?: Resolver<ResolversTypes['HookAction'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  trigger?: Resolver<ResolversTypes['HookTrigger'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HookActionResolvers<ContextType = any, ParentType extends ResolversParentTypes['HookAction'] = ResolversParentTypes['HookAction']> = {
  config?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['HookActionType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HookTriggerResolvers<ContextType = any, ParentType extends ResolversParentTypes['HookTrigger'] = ResolversParentTypes['HookTrigger']> = {
  config?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['HookTriggerType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface JsonScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['JSON'], any> {
  name: 'JSON';
}

export type MutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']> = {
  answerQuestion?: Resolver<ResolversTypes['PublicCertificate'], ParentType, ContextType, RequireFields<MutationAnswerQuestionArgs, 'answer' | 'certificateId' | 'questionId'>>;
  createCertificate?: Resolver<ResolversTypes['Certificate'], ParentType, ContextType, RequireFields<MutationCreateCertificateArgs, 'certificateConfigurationId' | 'userId'>>;
  createCertificateConfiguration?: Resolver<ResolversTypes['CertificateConfiguration'], ParentType, ContextType, RequireFields<MutationCreateCertificateConfigurationArgs, 'academyId' | 'certificateConfiguration'>>;
  createHook?: Resolver<ResolversTypes['Hook'], ParentType, ContextType, RequireFields<MutationCreateHookArgs, 'academyId' | 'hook'>>;
  createTopic?: Resolver<ResolversTypes['Topic'], ParentType, ContextType, RequireFields<MutationCreateTopicArgs, 'academyId' | 'name'>>;
  deleteCertificate?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteCertificateArgs, '_id'>>;
  deleteCertificateConfiguration?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteCertificateConfigurationArgs, '_id'>>;
  deleteHook?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteHookArgs, '_id'>>;
  deleteTopic?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteTopicArgs, '_id'>>;
  echo?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationEchoArgs, 'str'>>;
  generateCertificatePdf?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationGenerateCertificatePdfArgs, 'certificateId'>>;
  softDeleteCertificateConfiguration?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationSoftDeleteCertificateConfigurationArgs, '_id'>>;
  startPublicCertification?: Resolver<ResolversTypes['PublicCertificate'], ParentType, ContextType, RequireFields<MutationStartPublicCertificationArgs, '_id'>>;
  updateCertificateConfiguration?: Resolver<ResolversTypes['CertificateConfiguration'], ParentType, ContextType, RequireFields<MutationUpdateCertificateConfigurationArgs, '_id' | 'certificateConfiguration'>>;
  updateHook?: Resolver<ResolversTypes['Hook'], ParentType, ContextType, RequireFields<MutationUpdateHookArgs, '_id' | 'hook'>>;
  updateTopic?: Resolver<ResolversTypes['Topic'], ParentType, ContextType, RequireFields<MutationUpdateTopicArgs, '_id' | 'topic'>>;
};

export type PaginatedCertificatesListResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaginatedCertificatesList'] = ResolversParentTypes['PaginatedCertificatesList']> = {
  certificates?: Resolver<Array<ResolversTypes['Certificate']>, ParentType, ContextType>;
  documentCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PublicCertificateResolvers<ContextType = any, ParentType extends ResolversParentTypes['PublicCertificate'] = ResolversParentTypes['PublicCertificate']> = {
  _id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  certificateConfiguration?: Resolver<ResolversTypes['PublicCertificateConfiguration'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  currentQuestion?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  numOfQuestions?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  numOfQuestionsAnswered?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  questions?: Resolver<Array<ResolversTypes['JSON']>, ParentType, ContextType>;
  quizFinishedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  quizStartedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  receivedPointsPercentage?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  requiredPassingThresholdPercentage?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  state?: Resolver<ResolversTypes['CertificateState'], ParentType, ContextType>;
  timeLimitMs?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  user?: Resolver<ResolversTypes['PublicUser'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PublicCertificateConfigurationResolvers<ContextType = any, ParentType extends ResolversParentTypes['PublicCertificateConfiguration'] = ResolversParentTypes['PublicCertificateConfiguration']> = {
  _id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  description?: Resolver<Array<ResolversTypes['JSON']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PublicUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['PublicUser'] = ResolversParentTypes['PublicUser']> = {
  _id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  firstname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QueryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = {
  certificate?: Resolver<Maybe<ResolversTypes['Certificate']>, ParentType, ContextType, RequireFields<QueryCertificateArgs, '_id'>>;
  certificateConfiguration?: Resolver<Maybe<ResolversTypes['CertificateConfiguration']>, ParentType, ContextType, RequireFields<QueryCertificateConfigurationArgs, '_id'>>;
  certificateConfigurations?: Resolver<Array<ResolversTypes['CertificateConfiguration']>, ParentType, ContextType, RequireFields<QueryCertificateConfigurationsArgs, 'academyId'>>;
  certificates?: Resolver<ResolversTypes['PaginatedCertificatesList'], ParentType, ContextType, RequireFields<QueryCertificatesArgs, 'academyId' | 'limit' | 'page'>>;
  hook?: Resolver<Maybe<ResolversTypes['Hook']>, ParentType, ContextType, RequireFields<QueryHookArgs, '_id'>>;
  hooks?: Resolver<Array<ResolversTypes['Hook']>, ParentType, ContextType, RequireFields<QueryHooksArgs, 'academyId'>>;
  myCertificates?: Resolver<Array<ResolversTypes['Certificate']>, ParentType, ContextType>;
  publicCertificate?: Resolver<Maybe<ResolversTypes['PublicCertificate']>, ParentType, ContextType, RequireFields<QueryPublicCertificateArgs, '_id'>>;
  topic?: Resolver<Maybe<ResolversTypes['Topic']>, ParentType, ContextType, RequireFields<QueryTopicArgs, '_id'>>;
  topics?: Resolver<Array<ResolversTypes['Topic']>, ParentType, ContextType, RequireFields<QueryTopicsArgs, 'academyId'>>;
  trainings?: Resolver<Array<ResolversTypes['Training']>, ParentType, ContextType, RequireFields<QueryTrainingsArgs, 'academyId'>>;
  users?: Resolver<Array<ResolversTypes['User']>, ParentType, ContextType, RequireFields<QueryUsersArgs, never>>;
  version?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export interface TimeScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Time'], any> {
  name: 'Time';
}

export type TopicResolvers<ContextType = any, ParentType extends ResolversParentTypes['Topic'] = ResolversParentTypes['Topic']> = {
  _id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  academyId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  questions?: Resolver<Array<ResolversTypes['JSON']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TrainingResolvers<ContextType = any, ParentType extends ResolversParentTypes['Training'] = ResolversParentTypes['Training']> = {
  _id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserResolvers<ContextType = any, ParentType extends ResolversParentTypes['User'] = ResolversParentTypes['User']> = {
  _id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  firstname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Resolvers<ContextType = any> = {
  Certificate?: CertificateResolvers<ContextType>;
  CertificateConfiguration?: CertificateConfigurationResolvers<ContextType>;
  Date?: GraphQLScalarType;
  DateTime?: GraphQLScalarType;
  Hook?: HookResolvers<ContextType>;
  HookAction?: HookActionResolvers<ContextType>;
  HookTrigger?: HookTriggerResolvers<ContextType>;
  JSON?: GraphQLScalarType;
  Mutation?: MutationResolvers<ContextType>;
  PaginatedCertificatesList?: PaginatedCertificatesListResolvers<ContextType>;
  PublicCertificate?: PublicCertificateResolvers<ContextType>;
  PublicCertificateConfiguration?: PublicCertificateConfigurationResolvers<ContextType>;
  PublicUser?: PublicUserResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  Time?: GraphQLScalarType;
  Topic?: TopicResolvers<ContextType>;
  Training?: TrainingResolvers<ContextType>;
  User?: UserResolvers<ContextType>;
};

export type DirectiveResolvers<ContextType = any> = {
  unauthenticated?: UnauthenticatedDirectiveResolver<any, any, ContextType>;
};
